interface FormatCurrencyOptions {
    precision?: number;
    strict?: boolean;
    currency?: string;
}

const DEFAULT_OPTIONS: Required<FormatCurrencyOptions> = {
    precision: 2,
    strict:    false,
    currency:  'USD',
};

/**
 * Format currency based on Intl.NumberFormat.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param {number | null | undefined} value - The numeric value to format.
 * @param {FormatCurrencyOptions} options - Formatting configuration.
 * @param {string} locale - Locale string (e.g., 'en-US', 'uk-UA').
 *
 * @returns {string | null | undefined} Formatted currency string or original null/undefined value.
 */
export default function formatCurrency(
    value: number | null | undefined,
    options: FormatCurrencyOptions = {},
    locale: string = 'en-US',
): string | null | undefined {
    if (value === null || value === undefined) {
        return value;
    }

    const { precision, strict, currency } = {
        ...DEFAULT_OPTIONS,
        ...options,
    };

    try {
        return new Intl.NumberFormat(locale, {
            style:                 'currency',
            minimumFractionDigits: precision,
            maximumFractionDigits: strict ? precision : undefined,
            currency,
        }).format(value);
    } catch {
        return value.toFixed(precision);
    }
}
